export const handleCatch = (error) => {
    if (error.response.status === 500) {
        console.error('[SPLUNK] - INTERNAL SERVER ERROR');
    }

    if (error.response.status !== 500) {
        console.error(`[SPLUNK] - ERROR ${error.response.status}`);
    }

    throw new Error(error);
};
